import { MotionPlugin } from "./MotionPlugin.js";
export async function loadMotionPlugin(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addPlugin(new MotionPlugin(engine), refresh);
}
